import PageViewIcon from "@mui/icons-material/Pageview";
import { Box, Tooltip } from "@mui/material";
import { isAxiosError } from "axios";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import { IDicomAccesses } from "../../../models/exams";
import {
  getTasyVueMotionUrl,
  getVueMotionUrl,
} from "../../../services/exams.service";
import { tokenTemporaryService } from "../../../services/tokenTemorary.service";
import IconButton from "../../UI/IconButton";

const translationPath = "page.exams.";

interface IVueMotionPacsProps {
  dicomAccesses: IDicomAccesses[];
}

const VueMotionPacs = ({ dicomAccesses }: IVueMotionPacsProps) => {
  const { t } = useTranslation();

  const isLogginTemporary = tokenTemporaryService.hasTemporaryAccessToken();

  const { sendRequest, loading } = useFetch(
    isLogginTemporary ? getTasyVueMotionUrl : getVueMotionUrl,
    {
      getErrorMessage: (error) =>
        isAxiosError(error) &&
        (error.code === "ECONNABORTED" ||
          error.message.toLowerCase().includes("timeout"))
          ? (t(translationPath + "pacsTimeoutError") as string)
          : undefined,
    },
  );

  const openVueMotion = useCallback(async () => {
    const dicomAccess = dicomAccesses.find((access) => !!access.dicomAccess)
      ?.dicomAccess;

    if (!dicomAccess) {
      return;
    }

    const { data, success } = await sendRequest({ Integrationid: dicomAccess });

    if (data && success) {
      window.open(data as string, "_blank");
    }
  }, [sendRequest, dicomAccesses]);

  return (
    <Tooltip title={t(translationPath + "view")} placement="right">
      <Box>
        <IconButton size="small" loading={loading} onClick={openVueMotion}>
          <PageViewIcon fontSize="small" />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default memo(VueMotionPacs);
